module.exports = __webpack_public_path__ + "img/daphne.22ac5c22.jpg";